import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { CopySvg } from './CopySvg'

export const AliCopyIcon = (props: PropsWithoutRef<IconBaseProps>) => (
  <Icon component={CopySvg} {...props} />
)
